<template>
  <div>
    <ButtonBack class="mb_m"/>

    <input-name />
    <input-description />
    <input-url />
    <input-location />
    <input-radius />
    <search-location class="mt_m"/>
    <slot></slot>

  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import InputName from '@/components/Tourism/InputName'
import InputDescription from '@/components/Tourism/InputDescription'
import InputUrl from '@/components/Tourism/InputUrl'
import InputLocation from '@/components/Tourism/InputLocation'
import InputRadius from '@/components/Tourism/InputRadius'
import SearchLocation from '@/components/Tourism/SearchLocation'

export default {
  components: {
    ButtonBack,
    InputName,
    InputDescription,
    InputUrl,
    InputLocation,
    InputRadius,
    SearchLocation
  }
}
</script>

<style lang="scss" scoped>
</style>
